import client from './client';
import type { CollectorStatus, SyncTriggerResponse } from '@/types';

export async function fetchCollectors() {
  const { data } = await client.get<CollectorStatus[]>('/collectors');
  return data;
}

export async function fetchCollector(name: string) {
  const { data } = await client.get<CollectorStatus>(`/collectors/${name}`);
  return data;
}

export async function triggerSync(collectorName: string) {
  const { data } = await client.post<SyncTriggerResponse>(
    `/collectors/${collectorName}/sync`,
  );
  return data;
}
